/**
 * SUPABASE RUNTIME CONFIGURATION
 *
 * The published build does not read .env, so values kept only there are
 * undefined at runtime and the client is never created. These two values are
 * therefore held here, in the bundle, where the published site can always
 * reach them.
 *
 * This is safe: both are browser-public by design. The URL is the project's
 * address and the key is the *publishable* (anon) key, which is intended to
 * ship in client code and grants nothing beyond what the project's RLS
 * policies allow. A service-role or secret key must NEVER be placed here.
 *
 * An environment variable of the same name still wins where one is provided,
 * so a real deployment can override these without a code change.
 */

const env = ((import.meta as unknown as { env?: Record<string, string> }).env ?? {}) as Record<
  string,
  string | undefined
>

const FALLBACK_URL = 'https://fdyfqzqogibrsqxueeaj.supabase.co'
const FALLBACK_PUBLISHABLE_KEY = 'sb_publishable_tQVieGED5whFw1z9ynJMuQ_4jVN7T3h'

export const SUPABASE_URL = (env.VITE_SUPABASE_URL || FALLBACK_URL).trim()

export const SUPABASE_PUBLISHABLE_KEY = (
  env.VITE_SUPABASE_PUBLISHABLE_KEY || FALLBACK_PUBLISHABLE_KEY
).trim()
